import { render, staticRenderFns } from "./AddNewIcon.vue?vue&type=template&id=20609063&"
import script from "./AddNewIcon.vue?vue&type=script&lang=js&"
export * from "./AddNewIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports